import CompanyForm from "./components/CompanyForm";

export default CompanyForm;
